import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {TrackingService} from '@services/tracking.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-code2auth',
    templateUrl: './code2auth.component.html',
    styleUrls: ['./code2auth.component.scss']
})
export class Code2authComponent implements OnInit {

    codeForm = new UntypedFormGroup({
        code: new UntypedFormControl('', Validators.required),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        public dialogRef: MatDialogRef<Code2authComponent>,
        public trackingService: TrackingService) {

    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.trackingService.sendEvent('code2auth_cancel', "", "");
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        console.log(this.codeForm.valid)
        if (this.codeForm.valid,this.codeForm.get('code').value) {
            if (this.codeForm.get('code').value) {
                this.trackingService.sendEvent('code2auth_valid', "", "");
                this.dialogRef.close(this.codeForm.get('code').value);
            }
        }
    }
}
